import React, {useContext, useEffect, useState} from 'react'
import {UserContext} from "../../../context/UserContext"
import ApiClient from "common/src/api/ApiClient";
import PromiseBuilder from "common/src/utils/PromiseUtils";

function UserCard() {

  const { user } = useContext(UserContext);
  const [agencyName, setAgencyName] = useState();

  useEffect(() => {
    fetchAgencyName();
  }, [])

  function fetchAgencyName() {
    let request = async () => ApiClient.get("/api/v1/booking/agency/name")
    new PromiseBuilder()
      .then(request)
      .then((res) => {
        setAgencyName(res.data.payload.agencyName)
      })
      .run();
  }

  return (
    <div className="user-card">
			<img src={user.profilePicture ?? 'https://cdn-icons-png.flaticon.com/512/4128/4128217.png'} alt="Profile"/>
			<div className="user-text">
				<p className="user-name">{user.firstName} {user.lastName}</p>
        <p className="user-role">{agencyName}</p>
			</div>
		</div>
  )
}

export default UserCard;
